// extracted by mini-css-extract-plugin
export default {"price":"YgSkF","price__value":"nb8BK"};